import Http from '../api/http';

export default class TabInfo extends Http {
  constructor() {
    super();
  }
  // tab所有选项查询
  tabInfo_getList() {
    return super.post('tabInfo/getList', ...arguments);
  }
  tabInfo_add() {
    return super.post('tabInfo/add', ...arguments);
  }
  tabInfo_update() {
    return super.post('tabInfo/update', ...arguments);
  }
  tabInfo_changeStatus() {
    return super.post('tabInfo/changeStatus', ...arguments);
  }
  // 查询设置tab配置值
  tabConfig_getInfos() {
    return super.post('tabConfig/getInfos', ...arguments);
  }
  // 不同用户设置Tab
  tabConfig_addOrUpdate() {
    return super.post('tabConfig/addOrUpdate', ...arguments);
  }
  /**
   * 探长分享 tab下拉
   * @returns
   */
  tabInfo_getListForDropDown() {
    return super.post('tabInfo/getListForDropDown', ...arguments);
  }
  /**
   * 新建或更新二级Tab分类时的一级分类下拉列表
   * @returns
   */
  tabInfo_getLevelOneListDropDown() {
    return super.post('tabInfo/getLevelOneListDropDown', ...arguments);
  }
  /**
   * 二级Tab列表
   * @returns
   */
  tabInfo_getListForLevelTwo() {
    return super.post('tabInfo/getListForLevelTwo', ...arguments);
  }
  /**
   * 新增二级Tab
   * @returns
   */
  tabInfo_addForLevelTwo() {
    return super.post('tabInfo/addForLevelTwo', ...arguments);
  }
  /**
   * 更新二级Tab
   * @returns
   */
  tabInfo_updateForLevelTwo() {
    return super.post('tabInfo/updateForLevelTwo', ...arguments);
  }
  /**
   * Tab级联下拉框数据列表
   * @returns
   */
  tabInfo_getTabInfosForMulti() {
    return super.post('tabInfo/getTabInfosForMulti', ...arguments);
  }
  /**
   * 编辑课程内容时-培训Tab级联下拉框数据列表
   * @returns
   */
  tabInfo_getTabInfosForMultiAndCourse() {
    return super.post('tabInfo/getTabInfosForMultiAndCourse', ...arguments);
  }
}
